<template>
  <el-select
    :style="{ width: width }"
    size="small"
    v-model="userId"
    :loading="isLoading"
    filterable
    clearable
    remote
    :remote-method="getList"
    placeholder="请选择"
  >
    <el-option v-for="item in list" :label="item.userName" :value="item.id" :key="item.id"></el-option>
  </el-select>
</template>

<script>
import { getAdminList } from './api.js';

export default {
  name: 'SelectAdmin',

  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    width: {
      type: String,
      default: '400px'
    }
  },

  computed: {
    userId: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false,
    }
  },

  created() {
    this.getList('');
  },

  methods: {
    async getList(query) {
      let params = { userName: query };
      this.list = await getAdminList(params);
    }
  }
}
</script>

<style></style>
